
<div id="modal" class="modal" [ngStyle]="{'padding-top':resize?'18%':'5%','margin-left':resize?'11%':'5%'}">
  <div class="modal-content" [ngClass]="modalClasses" [ngStyle]="{'resize':resize?'both':'none'}" cdkDrag cdkDragBoundary=".modal">
    <div class="modal-header-row" [ngStyle]="{'cursor': !isDraggable ? 'default' : 'move'}" cdkDragHandle>
      <span class="close" title="Close" (click)="closePopUp()">&times;</span>
      <br />
      <div class="modal-header">      
        <h6>{{modalText}}</h6>
      </div>
    </div>
    <br>
    <ng-content></ng-content>
  </div>
</div>
